// extracted by mini-css-extract-plugin
module.exports = {"root":"full-image-module--root--2CZH7"};